import common_translations from "../common.json";
import apac from "./apac.translation.json";
import app from "./app.json";
import bootstrap from "./bootstrap.translation.json";
import cars from "./cars.json";
import checkout from "./checkout.json";
import exchange from "./exchange.json";
import fintech from "./fintech.json";
import flights from "./flights.json";
import hotels from "./hotels.json";
import hsbcQa from "./hsbc-qa.translation.json";
import hsbcSg from "./hsbc-sg.translation.json";
import hsbcUae from "./hsbc-uae.translation.json";
import packages from "./packages.json";
import selfserve from "./self-serve.json";
import traveler from "./traveler.json";
import trips from "./trips.json";
import ui from "./ui.json";
import wallet from "./wallet.json";

const bundle = {
  ...common_translations,
  ...app,
  ...cars,
  ...checkout,
  ...exchange,
  ...fintech,
  ...flights,
  ...hotels,
  ...packages,
  ...selfserve,
  ...traveler,
  ...trips,
  ...ui,
  ...wallet,
};
export default bundle;

export const ar_defaultTranslations = bundle;
export const ar_bootstrapTranslations = bootstrap;

export const ar_apacTranslations = apac;
export const ar_hsbcSgTranslations = hsbcSg;
export const ar_hsbcUaeTranslations = hsbcUae;
export const ar_hsbcQaTranslations = hsbcQa;
